// source: api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_api_annotations_pb = require('./google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var plan_reviewer_pb = require('./plan.reviewer_pb.js');
goog.object.extend(proto, plan_reviewer_pb);
var icc_chapters_pb = require('./icc.chapters_pb.js');
goog.object.extend(proto, icc_chapters_pb);
var rag_pb = require('./rag_pb.js');
goog.object.extend(proto, rag_pb);
var compliance_report_pb = require('./compliance_report_pb.js');
goog.object.extend(proto, compliance_report_pb);
var task_pb = require('./task_pb.js');
goog.object.extend(proto, task_pb);
var model_config_pb = require('./model_config_pb.js');
goog.object.extend(proto, model_config_pb);
var page_scale_pb = require('./page_scale_pb.js');
goog.object.extend(proto, page_scale_pb);
var cat_graph_pb = require('./cat_graph_pb.js');
goog.object.extend(proto, cat_graph_pb);
var finding_video_pb = require('./finding_video_pb.js');
goog.object.extend(proto, finding_video_pb);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.DocumentType', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.InputFileMetadata', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.PagePointsBox', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.PageTextPosition', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.PageTextPositionAvailability', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.PageTextPositionFailureReason', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.PassageIndexState', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.PassageMatch', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.PlanHitEntity', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.PlanPassageHit', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.ProcessingStatus', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.ProjectAddress', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.ProjectMetadata', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.RegionFrameProvenance', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.displayName = 'proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.ProjectMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.displayName = 'proto.org.codetricks.construction.code.assistant.service.ProjectMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.displayName = 'proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.displayName = 'proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.displayName = 'proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.displayName = 'proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.displayName = 'proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.PageTextPosition.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.PageTextPosition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.PageTextPosition.displayName = 'proto.org.codetricks.construction.code.assistant.service.PageTextPosition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.ProjectAddress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.ProjectAddress.displayName = 'proto.org.codetricks.construction.code.assistant.service.ProjectAddress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.InputFileMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.displayName = 'proto.org.codetricks.construction.code.assistant.service.InputFileMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.displayName = 'proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.PagePointsBox = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.PagePointsBox, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.PagePointsBox.displayName = 'proto.org.codetricks.construction.code.assistant.service.PagePointsBox';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.displayName = 'proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.displayName = 'proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.displayName = 'proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.PlanHitEntity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.displayName = 'proto.org.codetricks.construction.code.assistant.service.PlanHitEntity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.PlanPassageHit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.displayName = 'proto.org.codetricks.construction.code.assistant.service.PlanPassageHit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
filter: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest;
  return proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilter();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filter = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest.prototype.getFilter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanIdsRequest.prototype.setFilter = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest;
  return proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
fileId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest;
  return proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string file_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
pageToken: jspb.Message.getFieldWithDefault(msg, 3, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest;
  return proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_size = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string page_token = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string file_id = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
pageNumber: jspb.Message.getFieldWithDefault(msg, 1, 0),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageId: jspb.Message.getFieldWithDefault(msg, 3, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 4, ""),
summary: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary}
 */
proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary;
  return proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary}
 */
proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int32 page_number = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string page_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.prototype.getPageId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.prototype.setPageId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string file_id = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string summary = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
pagesList: jspb.Message.toObjectList(msg.getPagesList(),
    proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.toObject, includeInstance),
nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
totalCount: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse;
  return proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.deserializeBinaryFromReader);
      msg.addPages(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * repeated ArchitecturalPlanPageSummary pages = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary>}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.prototype.getPagesList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.prototype.setPagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.prototype.addPages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.service.ArchitecturalPlanPageSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.prototype.clearPagesList = function() {
  return this.setPagesList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 total_count = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalPlanPagesResponse.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanPageRequest: (f = msg.getArchitecturalPlanPageRequest()) && proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.toObject(includeInstance, f),
pdfContent: msg.getPdfContent_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse;
  return proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.deserializeBinaryFromReader);
      msg.setArchitecturalPlanPageRequest(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPdfContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanPageRequest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest.serializeBinaryToWriter
    );
  }
  f = message.getPdfContent_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional GetArchitecturalPlanPageRequest architectural_plan_page_request = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse.prototype.getArchitecturalPlanPageRequest = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPageRequest|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse.prototype.setArchitecturalPlanPageRequest = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse.prototype.clearArchitecturalPlanPageRequest = function() {
  return this.setArchitecturalPlanPageRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse.prototype.hasArchitecturalPlanPageRequest = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes pdf_content = 2;
 * @return {!(string|Uint8Array)}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse.prototype.getPdfContent = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes pdf_content = 2;
 * This is a type-conversion wrapper around `getPdfContent()`
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse.prototype.getPdfContent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPdfContent()));
};


/**
 * optional bytes pdf_content = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPdfContent()`
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse.prototype.getPdfContent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPdfContent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetArchitecturalPlanPagePdfResponse.prototype.setPdfContent = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
fileId: jspb.Message.getFieldWithDefault(msg, 3, ""),
metadata: (f = msg.getMetadata()) && plan_reviewer_pb.ArchitecturalPlanPage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest;
  return proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 4:
      var value = new plan_reviewer_pb.ArchitecturalPlanPage;
      reader.readMessage(value,plan_reviewer_pb.ArchitecturalPlanPage.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      plan_reviewer_pb.ArchitecturalPlanPage.serializeBinaryToWriter
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string file_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional org.codetricks.construction.code.assistant.ArchitecturalPlanPage metadata = 4;
 * @return {?proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.prototype.getMetadata = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} */ (
    jspb.Message.getWrapperField(this, plan_reviewer_pb.ArchitecturalPlanPage, 4));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataRequest.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
metadata: (f = msg.getMetadata()) && plan_reviewer_pb.ArchitecturalPlanPage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse;
  return proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new plan_reviewer_pb.ArchitecturalPlanPage;
      reader.readMessage(value,plan_reviewer_pb.ArchitecturalPlanPage.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      plan_reviewer_pb.ArchitecturalPlanPage.serializeBinaryToWriter
    );
  }
};


/**
 * optional org.codetricks.construction.code.assistant.ArchitecturalPlanPage metadata = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse.prototype.getMetadata = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} */ (
    jspb.Message.getWrapperField(this, plan_reviewer_pb.ArchitecturalPlanPage, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateArchitecturalPlanPageMetadataResponse.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageId: jspb.Message.getFieldWithDefault(msg, 2, ""),
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 3, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 4, 0),
fileId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest;
  return proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string page_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.prototype.getPageId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.prototype.setPageId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string architectural_plan_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 page_number = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string file_id = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
metadata: (f = msg.getMetadata()) && plan_reviewer_pb.ArchitecturalPlanPage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse;
  return proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new plan_reviewer_pb.ArchitecturalPlanPage;
      reader.readMessage(value,plan_reviewer_pb.ArchitecturalPlanPage.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      plan_reviewer_pb.ArchitecturalPlanPage.serializeBinaryToWriter
    );
  }
};


/**
 * optional org.codetricks.construction.code.assistant.ArchitecturalPlanPage metadata = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage}
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse.prototype.getMetadata = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage} */ (
    jspb.Message.getWrapperField(this, plan_reviewer_pb.ArchitecturalPlanPage, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.ArchitecturalPlanPage|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GroomArchitecturalPlanPageMetadataResponse.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalProjectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest;
  return proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string architectural_project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest.prototype.getArchitecturalProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesRequest.prototype.setArchitecturalProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalProjectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
filePathsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse;
  return proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addFilePaths(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilePathsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string architectural_project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse.prototype.getArchitecturalProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse.prototype.setArchitecturalProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string file_paths = 2;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse.prototype.getFilePathsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse.prototype.setFilePathsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse.prototype.addFilePaths = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListArchitecturalProjectInputFilesResponse.prototype.clearFilePathsList = function() {
  return this.setFilePathsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalProjectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest;
  return proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string architectural_project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest.prototype.getArchitecturalProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataRequest.prototype.setArchitecturalProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
metadata: (f = msg.getMetadata()) && proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.toObject(includeInstance, f),
architecturalProjectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
architecturalProjectName: jspb.Message.getFieldWithDefault(msg, 3, ""),
description: jspb.Message.getFieldWithDefault(msg, 4, ""),
createdBy: jspb.Message.getFieldWithDefault(msg, 5, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 6, ""),
status: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse;
  return proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.service.ProjectMetadata;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalProjectName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.serializeBinaryToWriter
    );
  }
  f = message.getArchitecturalProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getArchitecturalProjectName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional ProjectMetadata metadata = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.service.ProjectMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.prototype.getMetadata = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.ProjectMetadata, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.ProjectMetadata|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string architectural_project_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.prototype.getArchitecturalProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.prototype.setArchitecturalProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string architectural_project_name = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.prototype.getArchitecturalProjectName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.prototype.setArchitecturalProjectName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string created_by = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string created_at = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string status = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetProjectMetadataResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
projectName: jspb.Message.getFieldWithDefault(msg, 2, ""),
projectDescription: jspb.Message.getFieldWithDefault(msg, 3, ""),
createdBy: jspb.Message.getFieldWithDefault(msg, 4, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 5, ""),
updatedBy: jspb.Message.getFieldWithDefault(msg, 6, ""),
updatedAt: jspb.Message.getFieldWithDefault(msg, 7, ""),
status: jspb.Message.getFieldWithDefault(msg, 8, ""),
projectAddress: (f = msg.getProjectAddress()) && proto.org.codetricks.construction.code.assistant.service.ProjectAddress.toObject(includeInstance, f),
primaryBuildingCode: jspb.Message.getFieldWithDefault(msg, 10, ""),
jurisdiction: jspb.Message.getFieldWithDefault(msg, 11, ""),
projectType: jspb.Message.getFieldWithDefault(msg, 12, ""),
modelConfig: (f = msg.getModelConfig()) && model_config_pb.ProjectModelConfig.toObject(includeInstance, f),
ingestionSettings: (f = msg.getIngestionSettings()) && proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.toObject(includeInstance, f),
powerUserMode: (f = jspb.Message.getBooleanField(msg, 22)) == null ? undefined : f,
progressSummary: (f = msg.getProgressSummary()) && proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.toObject(includeInstance, f),
createdByUid: jspb.Message.getFieldWithDefault(msg, 24, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.ProjectMetadata;
  return proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedBy(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedAt(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 9:
      var value = new proto.org.codetricks.construction.code.assistant.service.ProjectAddress;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.ProjectAddress.deserializeBinaryFromReader);
      msg.setProjectAddress(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrimaryBuildingCode(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setJurisdiction(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectType(value);
      break;
    case 20:
      var value = new model_config_pb.ProjectModelConfig;
      reader.readMessage(value,model_config_pb.ProjectModelConfig.deserializeBinaryFromReader);
      msg.setModelConfig(value);
      break;
    case 21:
      var value = new proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.deserializeBinaryFromReader);
      msg.setIngestionSettings(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPowerUserMode(value);
      break;
    case 23:
      var value = new proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.deserializeBinaryFromReader);
      msg.setProgressSummary(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedByUid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProjectDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUpdatedBy();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getProjectAddress();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.org.codetricks.construction.code.assistant.service.ProjectAddress.serializeBinaryToWriter
    );
  }
  f = message.getPrimaryBuildingCode();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getJurisdiction();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getProjectType();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getModelConfig();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      model_config_pb.ProjectModelConfig.serializeBinaryToWriter
    );
  }
  f = message.getIngestionSettings();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeBool(
      22,
      f
    );
  }
  f = message.getProgressSummary();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.serializeBinaryToWriter
    );
  }
  f = message.getCreatedByUid();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_name = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.getProjectName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.setProjectName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string project_description = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.getProjectDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.setProjectDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string created_by = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string created_at = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string updated_by = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.getUpdatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.setUpdatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string updated_at = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.getUpdatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string status = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional ProjectAddress project_address = 9;
 * @return {?proto.org.codetricks.construction.code.assistant.service.ProjectAddress}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.getProjectAddress = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.ProjectAddress} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.ProjectAddress, 9));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.ProjectAddress|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
*/
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.setProjectAddress = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.clearProjectAddress = function() {
  return this.setProjectAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.hasProjectAddress = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string primary_building_code = 10;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.getPrimaryBuildingCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.setPrimaryBuildingCode = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string jurisdiction = 11;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.getJurisdiction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.setJurisdiction = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string project_type = 12;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.getProjectType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.setProjectType = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig model_config = 20;
 * @return {?proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.getModelConfig = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig} */ (
    jspb.Message.getWrapperField(this, model_config_pb.ProjectModelConfig, 20));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.ai.config.ProjectModelConfig|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
*/
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.setModelConfig = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.clearModelConfig = function() {
  return this.setModelConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.hasModelConfig = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional ProjectIngestionSettings ingestion_settings = 21;
 * @return {?proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.getIngestionSettings = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings, 21));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
*/
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.setIngestionSettings = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.clearIngestionSettings = function() {
  return this.setIngestionSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.hasIngestionSettings = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional bool power_user_mode = 22;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.getPowerUserMode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.setPowerUserMode = function(value) {
  return jspb.Message.setField(this, 22, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.clearPowerUserMode = function() {
  return jspb.Message.setField(this, 22, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.hasPowerUserMode = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional ProjectProgressSummary progress_summary = 23;
 * @return {?proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.getProgressSummary = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary, 23));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
*/
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.setProgressSummary = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.clearProgressSummary = function() {
  return this.setProgressSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.hasProgressSummary = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional string created_by_uid = 24;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.getCreatedByUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.prototype.setCreatedByUid = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
ingestedPagesCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
analyzedPagesCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
complianceSectionsCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 4, ""),
uploadedPagesCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
hasUploadedPagesCount: (f = jspb.Message.getBooleanField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary;
  return proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIngestedPagesCount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAnalyzedPagesCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setComplianceSectionsCount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedAt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUploadedPagesCount(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasUploadedPagesCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIngestedPagesCount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAnalyzedPagesCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getComplianceSectionsCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUploadedPagesCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional int32 ingested_pages_count = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.prototype.getIngestedPagesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.prototype.setIngestedPagesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 analyzed_pages_count = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.prototype.getAnalyzedPagesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.prototype.setAnalyzedPagesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 compliance_sections_count = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.prototype.getComplianceSectionsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.prototype.setComplianceSectionsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string updated_at = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.prototype.getUpdatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 uploaded_pages_count = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.prototype.getUploadedPagesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.prototype.setUploadedPagesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool has_uploaded_pages_count = 6;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.prototype.getHasUploadedPagesCount = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.prototype.setHasUploadedPagesCount = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.prototype.clearHasUploadedPagesCount = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectProgressSummary.prototype.hasHasUploadedPagesCount = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
enableVisualVerification: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
enableRegionHierarchy: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
regionHierarchyConfigJson: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings;
  return proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableVisualVerification(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRegionHierarchy(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegionHierarchyConfigJson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnableVisualVerification();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getEnableRegionHierarchy();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getRegionHierarchyConfigJson();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional bool enable_visual_verification = 1;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.prototype.getEnableVisualVerification = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.prototype.setEnableVisualVerification = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool enable_region_hierarchy = 2;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.prototype.getEnableRegionHierarchy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.prototype.setEnableRegionHierarchy = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string region_hierarchy_config_json = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.prototype.getRegionHierarchyConfigJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectIngestionSettings.prototype.setRegionHierarchyConfigJson = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
fileId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest;
  return proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string file_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.repeatedFields_ = [7,12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
slug: jspb.Message.getFieldWithDefault(msg, 2, ""),
path: jspb.Message.getFieldWithDefault(msg, 3, ""),
nodeKind: jspb.Message.getFieldWithDefault(msg, 4, ""),
ncsClassification: jspb.Message.getFieldWithDefault(msg, 5, ""),
depth: jspb.Message.getFieldWithDefault(msg, 6, 0),
boundingBoxList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
transcript: jspb.Message.getFieldWithDefault(msg, 8, ""),
description: jspb.Message.getFieldWithDefault(msg, 9, ""),
identifiersMap: (f = msg.getIdentifiersMap()) ? f.toObject(includeInstance, undefined) : [],
childCount: jspb.Message.getFieldWithDefault(msg, 11, 0),
childNodesList: jspb.Message.toObjectList(msg.getChildNodesList(),
    proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.toObject, includeInstance),
boundingBoxRotationDegrees: (f = jspb.Message.getField(msg, 13)) == null ? undefined : f,
siblingOrder: (f = msg.getSiblingOrder()) && proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode;
  return proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNodeKind(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setNcsClassification(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDepth(value);
      break;
    case 7:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addBoundingBox(values[i]);
      }
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTranscript(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 10:
      var value = msg.getIdentifiersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChildCount(value);
      break;
    case 12:
      var value = new proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.deserializeBinaryFromReader);
      msg.addChildNodes(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBoundingBoxRotationDegrees(value);
      break;
    case 14:
      var value = new proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.deserializeBinaryFromReader);
      msg.setSiblingOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNodeKind();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getNcsClassification();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDepth();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getBoundingBoxList();
  if (f.length > 0) {
    writer.writePackedInt32(
      7,
      f
    );
  }
  f = message.getTranscript();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getIdentifiersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(10, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getChildCount();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getChildNodesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getSiblingOrder();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.serializeBinaryToWriter
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slug = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.setSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string path = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string node_kind = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.getNodeKind = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.setNodeKind = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string ncs_classification = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.getNcsClassification = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.setNcsClassification = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 depth = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.getDepth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.setDepth = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated int32 bounding_box = 7;
 * @return {!Array<number>}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.getBoundingBoxList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.setBoundingBoxList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.addBoundingBox = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.clearBoundingBoxList = function() {
  return this.setBoundingBoxList([]);
};


/**
 * optional string transcript = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.getTranscript = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.setTranscript = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string description = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * map<string, string> identifiers = 10;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.getIdentifiersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 10, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.clearIdentifiersMap = function() {
  this.getIdentifiersMap().clear();
  return this;
};


/**
 * optional int32 child_count = 11;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.getChildCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.setChildCount = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * repeated RegionHierarchyTreeNode child_nodes = 12;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode>}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.getChildNodesList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode, 12));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
*/
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.setChildNodesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.addChildNodes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.clearChildNodesList = function() {
  return this.setChildNodesList([]);
};


/**
 * optional int32 bounding_box_rotation_degrees = 13;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.getBoundingBoxRotationDegrees = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.setBoundingBoxRotationDegrees = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.clearBoundingBoxRotationDegrees = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.hasBoundingBoxRotationDegrees = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional RegionSiblingOrder sibling_order = 14;
 * @return {?proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.getSiblingOrder = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder, 14));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
*/
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.setSiblingOrder = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.clearSiblingOrder = function() {
  return this.setSiblingOrder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.prototype.hasSiblingOrder = function() {
  return jspb.Message.getField(this, 14) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.toObject = function(includeInstance, msg) {
  var f, obj = {
rank: jspb.Message.getFieldWithDefault(msg, 1, 0),
provenance: jspb.Message.getFieldWithDefault(msg, 2, ""),
ordinal: jspb.Message.getFieldWithDefault(msg, 3, ""),
ordinalSource: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder}
 */
proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder;
  return proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder}
 */
proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRank(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProvenance(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrdinal(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrdinalSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getProvenance();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrdinal();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOrdinalSource();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int32 rank = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string provenance = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.prototype.getProvenance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.prototype.setProvenance = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ordinal = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.prototype.getOrdinal = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.prototype.setOrdinal = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ordinal_source = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.prototype.getOrdinalSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RegionSiblingOrder.prototype.setOrdinalSource = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.toObject = function(includeInstance, msg) {
  var f, obj = {
displayRotationDegrees: jspb.Message.getFieldWithDefault(msg, 1, 0),
geometryRevision: jspb.Message.getFieldWithDefault(msg, 2, 0),
nativeRotationDegrees: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
ingestionCorrectionDegrees: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
userRotationDegrees: jspb.Message.getFieldWithDefault(msg, 5, 0),
regionRotationAtCaptureDegrees: jspb.Message.getFieldWithDefault(msg, 6, 0),
regionFrameProvenance: jspb.Message.getFieldWithDefault(msg, 7, 0),
textPositionRotationDegrees: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
pageRevision: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection}
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection;
  return proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection}
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayRotationDegrees(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setGeometryRevision(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNativeRotationDegrees(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIngestionCorrectionDegrees(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserRotationDegrees(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRegionRotationAtCaptureDegrees(value);
      break;
    case 7:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.service.RegionFrameProvenance} */ (reader.readEnum());
      msg.setRegionFrameProvenance(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTextPositionRotationDegrees(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageRevision(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisplayRotationDegrees();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getGeometryRevision();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getUserRotationDegrees();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getRegionRotationAtCaptureDegrees();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getRegionFrameProvenance();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getPageRevision();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional int32 display_rotation_degrees = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.getDisplayRotationDegrees = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.setDisplayRotationDegrees = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 geometry_revision = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.getGeometryRevision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.setGeometryRevision = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 native_rotation_degrees = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.getNativeRotationDegrees = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.setNativeRotationDegrees = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.clearNativeRotationDegrees = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.hasNativeRotationDegrees = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 ingestion_correction_degrees = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.getIngestionCorrectionDegrees = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.setIngestionCorrectionDegrees = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.clearIngestionCorrectionDegrees = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.hasIngestionCorrectionDegrees = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 user_rotation_degrees = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.getUserRotationDegrees = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.setUserRotationDegrees = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 region_rotation_at_capture_degrees = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.getRegionRotationAtCaptureDegrees = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.setRegionRotationAtCaptureDegrees = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional RegionFrameProvenance region_frame_provenance = 7;
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionFrameProvenance}
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.getRegionFrameProvenance = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.service.RegionFrameProvenance} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.RegionFrameProvenance} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.setRegionFrameProvenance = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional int32 text_position_rotation_degrees = 8;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.getTextPositionRotationDegrees = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.setTextPositionRotationDegrees = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.clearTextPositionRotationDegrees = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.hasTextPositionRotationDegrees = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string page_revision = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.getPageRevision = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.prototype.setPageRevision = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.repeatedFields_ = [1,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
nodesList: jspb.Message.toObjectList(msg.getNodesList(),
    proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.toObject, includeInstance),
totalNodeCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
hasHierarchy: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
textPositionsList: jspb.Message.toObjectList(msg.getTextPositionsList(),
    proto.org.codetricks.construction.code.assistant.service.PageTextPosition.toObject, includeInstance),
positionalOcrStatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
positionalOcrFailureReason: jspb.Message.getFieldWithDefault(msg, 6, 0),
geometry: (f = msg.getGeometry()) && proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse;
  return proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.deserializeBinaryFromReader);
      msg.addNodes(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalNodeCount(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasHierarchy(value);
      break;
    case 4:
      var value = new proto.org.codetricks.construction.code.assistant.service.PageTextPosition;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.PageTextPosition.deserializeBinaryFromReader);
      msg.addTextPositions(value);
      break;
    case 5:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.service.PageTextPositionAvailability} */ (reader.readEnum());
      msg.setPositionalOcrStatus(value);
      break;
    case 6:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.service.PageTextPositionFailureReason} */ (reader.readEnum());
      msg.setPositionalOcrFailureReason(value);
      break;
    case 7:
      var value = new proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.deserializeBinaryFromReader);
      msg.setGeometry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNodesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.serializeBinaryToWriter
    );
  }
  f = message.getTotalNodeCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getHasHierarchy();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTextPositionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.org.codetricks.construction.code.assistant.service.PageTextPosition.serializeBinaryToWriter
    );
  }
  f = message.getPositionalOcrStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getPositionalOcrFailureReason();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getGeometry();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RegionHierarchyTreeNode nodes = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode>}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.getNodesList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.setNodesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.addNodes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.clearNodesList = function() {
  return this.setNodesList([]);
};


/**
 * optional int32 total_node_count = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.getTotalNodeCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.setTotalNodeCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool has_hierarchy = 3;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.getHasHierarchy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.setHasHierarchy = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated PageTextPosition text_positions = 4;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.PageTextPosition>}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.getTextPositionsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.PageTextPosition>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.PageTextPosition, 4));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.PageTextPosition>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.setTextPositionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.PageTextPosition=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageTextPosition}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.addTextPositions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.org.codetricks.construction.code.assistant.service.PageTextPosition, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.clearTextPositionsList = function() {
  return this.setTextPositionsList([]);
};


/**
 * optional PageTextPositionAvailability positional_ocr_status = 5;
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageTextPositionAvailability}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.getPositionalOcrStatus = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.service.PageTextPositionAvailability} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.PageTextPositionAvailability} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.setPositionalOcrStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional PageTextPositionFailureReason positional_ocr_failure_reason = 6;
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageTextPositionFailureReason}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.getPositionalOcrFailureReason = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.service.PageTextPositionFailureReason} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.PageTextPositionFailureReason} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.setPositionalOcrFailureReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional PageGeometryProjection geometry = 7;
 * @return {?proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.getGeometry = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection, 7));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.PageGeometryProjection|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.setGeometry = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.clearGeometry = function() {
  return this.setGeometry(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionHierarchyResponse.prototype.hasGeometry = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.PageTextPosition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.PageTextPosition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.toObject = function(includeInstance, msg) {
  var f, obj = {
text: jspb.Message.getFieldWithDefault(msg, 1, ""),
boundingBoxList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
readingOrder: jspb.Message.getFieldWithDefault(msg, 3, 0),
confidence: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
lineOrder: jspb.Message.getFieldWithDefault(msg, 5, 0),
layoutOrder: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageTextPosition}
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.PageTextPosition;
  return proto.org.codetricks.construction.code.assistant.service.PageTextPosition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.PageTextPosition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageTextPosition}
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addBoundingBox(values[i]);
      }
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReadingOrder(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setConfidence(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLineOrder(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLayoutOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.PageTextPosition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.PageTextPosition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBoundingBoxList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
  f = message.getReadingOrder();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getConfidence();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getLineOrder();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getLayoutOrder();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional string text = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageTextPosition} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated int32 bounding_box = 2;
 * @return {!Array<number>}
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.prototype.getBoundingBoxList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageTextPosition} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.prototype.setBoundingBoxList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageTextPosition} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.prototype.addBoundingBox = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageTextPosition} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.prototype.clearBoundingBoxList = function() {
  return this.setBoundingBoxList([]);
};


/**
 * optional int32 reading_order = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.prototype.getReadingOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageTextPosition} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.prototype.setReadingOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional float confidence = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.prototype.getConfidence = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageTextPosition} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.prototype.setConfidence = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int32 line_order = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.prototype.getLineOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageTextPosition} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.prototype.setLineOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 layout_order = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.prototype.getLayoutOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageTextPosition} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPosition.prototype.setLayoutOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.ProjectAddress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProjectAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.toObject = function(includeInstance, msg) {
  var f, obj = {
street: jspb.Message.getFieldWithDefault(msg, 1, ""),
city: jspb.Message.getFieldWithDefault(msg, 2, ""),
state: jspb.Message.getFieldWithDefault(msg, 3, ""),
postalCode: jspb.Message.getFieldWithDefault(msg, 4, ""),
country: jspb.Message.getFieldWithDefault(msg, 5, ""),
googlePlaceId: jspb.Message.getFieldWithDefault(msg, 6, ""),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
formattedAddress: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectAddress}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.ProjectAddress;
  return proto.org.codetricks.construction.code.assistant.service.ProjectAddress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProjectAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectAddress}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreet(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostalCode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setGooglePlaceId(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormattedAddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.ProjectAddress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProjectAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStreet();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPostalCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getGooglePlaceId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getFormattedAddress();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string street = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.getStreet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectAddress} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.setStreet = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string city = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectAddress} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string state = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectAddress} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string postal_code = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.getPostalCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectAddress} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.setPostalCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string country = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectAddress} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string google_place_id = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.getGooglePlaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectAddress} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.setGooglePlaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional double latitude = 7;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectAddress} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double longitude = 8;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectAddress} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional string formatted_address = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.getFormattedAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProjectAddress} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProjectAddress.prototype.setFormattedAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
metadata: (f = msg.getMetadata()) && proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest}
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest;
  return proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest}
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.service.ProjectMetadata;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.serializeBinaryToWriter
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ProjectMetadata metadata = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.service.ProjectMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest.prototype.getMetadata = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.ProjectMetadata, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.ProjectMetadata|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataRequest.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
metadata: (f = msg.getMetadata()) && proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse}
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse;
  return proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse}
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.service.ProjectMetadata;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.serializeBinaryToWriter
    );
  }
};


/**
 * optional ProjectMetadata metadata = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.service.ProjectMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse.prototype.getMetadata = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.ProjectMetadata, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.ProjectMetadata|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.CreateProjectMetadataResponse.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
metadata: (f = msg.getMetadata()) && proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest;
  return proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.service.ProjectMetadata;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.serializeBinaryToWriter
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ProjectMetadata metadata = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.service.ProjectMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest.prototype.getMetadata = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.ProjectMetadata, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.ProjectMetadata|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataRequest.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
metadata: (f = msg.getMetadata()) && proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse;
  return proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.service.ProjectMetadata;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.service.ProjectMetadata.serializeBinaryToWriter
    );
  }
};


/**
 * optional ProjectMetadata metadata = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.service.ProjectMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse.prototype.getMetadata = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.ProjectMetadata} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.ProjectMetadata, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.ProjectMetadata|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.UpdateProjectMetadataResponse.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
inputFilePath: jspb.Message.getFieldWithDefault(msg, 2, ""),
forceRegenerate: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest;
  return proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInputFilePath(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setForceRegenerate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInputFilePath();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getForceRegenerate();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string input_file_path = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest.prototype.getInputFilePath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest.prototype.setInputFilePath = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool force_regenerate = 3;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest.prototype.getForceRegenerate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataRequest.prototype.setForceRegenerate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
fileId: jspb.Message.getFieldWithDefault(msg, 1, ""),
metadata: (f = msg.getMetadata()) && proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.toObject(includeInstance, f),
success: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
errorMessage: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse;
  return proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.service.InputFileMetadata;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.serializeBinaryToWriter
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string file_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional InputFileMetadata metadata = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.service.InputFileMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.prototype.getMetadata = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.InputFileMetadata, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.InputFileMetadata|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool success = 3;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string error_message = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateInputFileMetadataResponse.prototype.setErrorMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 2, ""),
autoGenerateIfMissing: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest;
  return proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutoGenerateIfMissing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAutoGenerateIfMissing();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool auto_generate_if_missing = 3;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest.prototype.getAutoGenerateIfMissing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataRequest.prototype.setAutoGenerateIfMissing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
metadata: (f = msg.getMetadata()) && proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.toObject(includeInstance, f),
found: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
autoGenerated: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
errorMessage: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse;
  return proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.service.InputFileMetadata;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFound(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutoGenerated(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.serializeBinaryToWriter
    );
  }
  f = message.getFound();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getAutoGenerated();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional InputFileMetadata metadata = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.service.InputFileMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.prototype.getMetadata = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.InputFileMetadata, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.InputFileMetadata|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool found = 2;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.prototype.getFound = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.prototype.setFound = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool auto_generated = 3;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.prototype.getAutoGenerated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.prototype.setAutoGenerated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string error_message = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetInputFileMetadataResponse.prototype.setErrorMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
pageToken: jspb.Message.getFieldWithDefault(msg, 3, ""),
documentTypeFilter: jspb.Message.getFieldWithDefault(msg, 4, 0),
statusFilter: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest}
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest;
  return proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest}
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    case 4:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.service.DocumentType} */ (reader.readEnum());
      msg.setDocumentTypeFilter(value);
      break;
    case 5:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.service.ProcessingStatus} */ (reader.readEnum());
      msg.setStatusFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDocumentTypeFilter();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getStatusFilter();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_size = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string page_token = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional DocumentType document_type_filter = 4;
 * @return {!proto.org.codetricks.construction.code.assistant.service.DocumentType}
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.prototype.getDocumentTypeFilter = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.service.DocumentType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.DocumentType} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.prototype.setDocumentTypeFilter = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional ProcessingStatus status_filter = 5;
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProcessingStatus}
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.prototype.getStatusFilter = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.service.ProcessingStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProcessingStatus} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataRequest.prototype.setStatusFilter = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
filesList: jspb.Message.toObjectList(msg.getFilesList(),
    proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.toObject, includeInstance),
nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
totalCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
errorMessage: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse}
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse;
  return proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse}
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.service.InputFileMetadata;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.deserializeBinaryFromReader);
      msg.addFiles(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * repeated InputFileMetadata files = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata>}
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.prototype.getFilesList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.InputFileMetadata, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.prototype.setFilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.prototype.addFiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.service.InputFileMetadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.prototype.clearFilesList = function() {
  return this.setFilesList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 total_count = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string error_message = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListInputFileMetadataResponse.prototype.setErrorMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.repeatedFields_ = [11,13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
fileId: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileName: jspb.Message.getFieldWithDefault(msg, 2, ""),
filePath: jspb.Message.getFieldWithDefault(msg, 3, ""),
mimeType: jspb.Message.getFieldWithDefault(msg, 4, ""),
fileSizeBytes: jspb.Message.getFieldWithDefault(msg, 5, 0),
uploadDate: jspb.Message.getFieldWithDefault(msg, 6, ""),
documentType: jspb.Message.getFieldWithDefault(msg, 7, 0),
pageCount: jspb.Message.getFieldWithDefault(msg, 8, 0),
processingStatus: jspb.Message.getFieldWithDefault(msg, 9, 0),
processedDate: jspb.Message.getFieldWithDefault(msg, 10, ""),
extractedPagesList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
contentSummary: jspb.Message.getFieldWithDefault(msg, 12, ""),
detectedElementsList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
checksumMd5: jspb.Message.getFieldWithDefault(msg, 14, ""),
originalPath: jspb.Message.getFieldWithDefault(msg, 15, ""),
metadataError: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.InputFileMetadata;
  return proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilePath(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFileSizeBytes(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUploadDate(value);
      break;
    case 7:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.service.DocumentType} */ (reader.readEnum());
      msg.setDocumentType(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageCount(value);
      break;
    case 9:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.service.ProcessingStatus} */ (reader.readEnum());
      msg.setProcessingStatus(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setProcessedDate(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.addExtractedPages(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentSummary(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.addDetectedElements(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setChecksumMd5(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginalPath(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setMetadataError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFilePath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFileSizeBytes();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getUploadDate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDocumentType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getPageCount();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getProcessingStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getProcessedDate();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getExtractedPagesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      11,
      f
    );
  }
  f = message.getContentSummary();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getDetectedElementsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      13,
      f
    );
  }
  f = message.getChecksumMd5();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getOriginalPath();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getMetadataError();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional string file_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_name = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_path = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.getFilePath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.setFilePath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string mime_type = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 file_size_bytes = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.getFileSizeBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.setFileSizeBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string upload_date = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.getUploadDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.setUploadDate = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional DocumentType document_type = 7;
 * @return {!proto.org.codetricks.construction.code.assistant.service.DocumentType}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.getDocumentType = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.service.DocumentType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.DocumentType} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.setDocumentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional int32 page_count = 8;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.getPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.setPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional ProcessingStatus processing_status = 9;
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProcessingStatus}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.getProcessingStatus = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.service.ProcessingStatus} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProcessingStatus} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.setProcessingStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional string processed_date = 10;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.getProcessedDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.setProcessedDate = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * repeated string extracted_pages = 11;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.getExtractedPagesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.setExtractedPagesList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.addExtractedPages = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.clearExtractedPagesList = function() {
  return this.setExtractedPagesList([]);
};


/**
 * optional string content_summary = 12;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.getContentSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.setContentSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * repeated string detected_elements = 13;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.getDetectedElementsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.setDetectedElementsList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.addDetectedElements = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.clearDetectedElementsList = function() {
  return this.setDetectedElementsList([]);
};


/**
 * optional string checksum_md5 = 14;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.getChecksumMd5 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.setChecksumMd5 = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string original_path = 15;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.getOriginalPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.setOriginalPath = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string metadata_error = 16;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.getMetadataError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.InputFileMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.InputFileMetadata.prototype.setMetadataError = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
projectName: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest}
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest;
  return proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest}
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_name = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest.prototype.getProjectName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest.prototype.setProjectName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
projectPath: jspb.Message.getFieldWithDefault(msg, 2, ""),
success: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
message: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse}
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse;
  return proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse}
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectPath(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectPath();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_path = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse.prototype.getProjectPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse.prototype.setProjectPath = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool success = 3;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string message = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CreateArchitecturalPlanResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
fileContent: msg.getFileContent_asB64(),
contentType: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest;
  return proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFileContent(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileContent_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
  f = message.getContentType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bytes file_content = 3;
 * @return {!(string|Uint8Array)}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.prototype.getFileContent = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes file_content = 3;
 * This is a type-conversion wrapper around `getFileContent()`
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.prototype.getFileContent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFileContent()));
};


/**
 * optional bytes file_content = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFileContent()`
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.prototype.getFileContent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFileContent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.prototype.setFileContent = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};


/**
 * optional string content_type = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.prototype.getContentType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectRequest.prototype.setContentType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
filePath: jspb.Message.getFieldWithDefault(msg, 3, ""),
success: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
message: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse;
  return proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilePath(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFilePath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_path = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.prototype.getFilePath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.prototype.setFilePath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool success = 4;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string message = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.UploadFileToProjectResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
contentType: jspb.Message.getFieldWithDefault(msg, 3, ""),
fileSize: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest;
  return proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFileSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContentType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFileSize();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string content_type = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest.prototype.getContentType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest.prototype.setContentType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 file_size = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest.prototype.getFileSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlRequest.prototype.setFileSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
uploadUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
expiresAt: jspb.Message.getFieldWithDefault(msg, 4, 0),
success: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
message: jspb.Message.getFieldWithDefault(msg, 6, ""),
replacesExistingFile: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
originalFilename: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse;
  return proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUploadUrl(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiresAt(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReplacesExistingFile(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginalFilename(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUploadUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExpiresAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getReplacesExistingFile();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getOriginalFilename();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string upload_url = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.prototype.getUploadUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.prototype.setUploadUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 expires_at = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.prototype.getExpiresAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.prototype.setExpiresAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool success = 5;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string message = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool replaces_existing_file = 7;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.prototype.getReplacesExistingFile = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.prototype.setReplacesExistingFile = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string original_filename = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.prototype.getOriginalFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GenerateUploadUrlResponse.prototype.setOriginalFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
fileSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest;
  return proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFileSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileSize();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 file_size = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest.prototype.getFileSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteRequest.prototype.setFileSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
filePath: jspb.Message.getFieldWithDefault(msg, 3, ""),
success: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
message: jspb.Message.getFieldWithDefault(msg, 5, ""),
pageCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
uploadVerified: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
metadataGenerated: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
metadataError: jspb.Message.getFieldWithDefault(msg, 9, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse;
  return proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilePath(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageCount(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUploadVerified(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMetadataGenerated(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setMetadataError(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFilePath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPageCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getUploadVerified();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getMetadataGenerated();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getMetadataError();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_path = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.getFilePath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.setFilePath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool success = 4;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string message = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 page_count = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.getPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.setPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool upload_verified = 7;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.getUploadVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.setUploadVerified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool metadata_generated = 8;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.getMetadataGenerated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.setMetadataGenerated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string metadata_error = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.getMetadataError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.setMetadataError = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string file_id = 10;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.NotifyUploadCompleteResponse.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageNumbersList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
options: (f = msg.getOptions()) && task_pb.PageIngestionOptions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest;
  return proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPageNumbers(values[i]);
      }
      break;
    case 4:
      var value = new task_pb.PageIngestionOptions;
      reader.readMessage(value,task_pb.PageIngestionOptions.deserializeBinaryFromReader);
      msg.setOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageNumbersList();
  if (f.length > 0) {
    writer.writePackedInt32(
      3,
      f
    );
  }
  f = message.getOptions();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      task_pb.PageIngestionOptions.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated int32 page_numbers = 3;
 * @return {!Array<number>}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.prototype.getPageNumbersList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.prototype.setPageNumbersList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.prototype.addPageNumbers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.prototype.clearPageNumbersList = function() {
  return this.setPageNumbersList([]);
};


/**
 * optional PageIngestionOptions options = 4;
 * @return {?proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.prototype.getOptions = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions} */ (
    jspb.Message.getWrapperField(this, task_pb.PageIngestionOptions, 4));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.prototype.setOptions = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.prototype.clearOptions = function() {
  return this.setOptions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectRequest.prototype.hasOptions = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
pagesProcessed: jspb.Message.getFieldWithDefault(msg, 3, 0),
success: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
message: jspb.Message.getFieldWithDefault(msg, 5, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse;
  return proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPagesProcessed(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPagesProcessed();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 pages_processed = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.prototype.getPagesProcessed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.prototype.setPagesProcessed = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool success = 4;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string message = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string file_id = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.IngestFileIntoProjectResponse.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
sourceProjectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
targetProjectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
copySharingSettings: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest}
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest;
  return proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest}
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetProjectId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCopySharingSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSourceProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTargetProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCopySharingSettings();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string source_project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest.prototype.getSourceProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest.prototype.setSourceProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string target_project_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest.prototype.getTargetProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest.prototype.setTargetProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool copy_sharing_settings = 3;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest.prototype.getCopySharingSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanRequest.prototype.setCopySharingSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
sourceProjectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
targetProjectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
targetProjectPath: jspb.Message.getFieldWithDefault(msg, 3, ""),
success: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
message: jspb.Message.getFieldWithDefault(msg, 5, ""),
filesCopied: jspb.Message.getFieldWithDefault(msg, 6, 0),
bytesCopied: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse}
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse;
  return proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse}
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetProjectPath(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFilesCopied(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBytesCopied(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSourceProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTargetProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTargetProjectPath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFilesCopied();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getBytesCopied();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional string source_project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.prototype.getSourceProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.prototype.setSourceProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string target_project_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.prototype.getTargetProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.prototype.setTargetProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string target_project_path = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.prototype.getTargetProjectPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.prototype.setTargetProjectPath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool success = 4;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string message = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 files_copied = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.prototype.getFilesCopied = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.prototype.setFilesCopied = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 bytes_copied = 7;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.prototype.getBytesCopied = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CopyArchitecturalPlanResponse.prototype.setBytesCopied = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
confirmationDeleteText: jspb.Message.getFieldWithDefault(msg, 2, ""),
confirmationProjectId: jspb.Message.getFieldWithDefault(msg, 3, ""),
forceHardDelete: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest;
  return proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfirmationDeleteText(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfirmationProjectId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setForceHardDelete(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConfirmationDeleteText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConfirmationProjectId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getForceHardDelete();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string confirmation_delete_text = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest.prototype.getConfirmationDeleteText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest.prototype.setConfirmationDeleteText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string confirmation_project_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest.prototype.getConfirmationProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest.prototype.setConfirmationProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool force_hard_delete = 4;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest.prototype.getForceHardDelete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanRequest.prototype.setForceHardDelete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
message: jspb.Message.getFieldWithDefault(msg, 3, ""),
filesDeleted: jspb.Message.getFieldWithDefault(msg, 4, 0),
bytesDeleted: jspb.Message.getFieldWithDefault(msg, 5, 0),
deletedFilePathsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
hardDeleted: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse;
  return proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFilesDeleted(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBytesDeleted(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addDeletedFilePaths(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHardDeleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFilesDeleted();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getBytesDeleted();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getDeletedFilePathsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getHardDeleted();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 files_deleted = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.prototype.getFilesDeleted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.prototype.setFilesDeleted = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 bytes_deleted = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.prototype.getBytesDeleted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.prototype.setBytesDeleted = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated string deleted_file_paths = 6;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.prototype.getDeletedFilePathsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.prototype.setDeletedFilePathsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.prototype.addDeletedFilePaths = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.prototype.clearDeletedFilePathsList = function() {
  return this.setDeletedFilePathsList([]);
};


/**
 * optional bool hard_deleted = 7;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.prototype.getHardDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.DeleteArchitecturalPlanResponse.prototype.setHardDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest;
  return proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse;
  return proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.DeleteInputFileResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
degrees: jspb.Message.getFieldWithDefault(msg, 3, 0),
fileId: jspb.Message.getFieldWithDefault(msg, 4, ""),
expectedRotationDegrees: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest;
  return proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDegrees(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExpectedRotationDegrees(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDegrees();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 degrees = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.prototype.getDegrees = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.prototype.setDegrees = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string file_id = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 expected_rotation_degrees = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.prototype.getExpectedRotationDegrees = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.prototype.setExpectedRotationDegrees = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.prototype.clearExpectedRotationDegrees = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageRequest.prototype.hasExpectedRotationDegrees = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
previousRotationDegrees: jspb.Message.getFieldWithDefault(msg, 3, 0),
effectiveRotationDegrees: jspb.Message.getFieldWithDefault(msg, 4, 0),
geometryRevision: jspb.Message.getFieldWithDefault(msg, 5, 0),
alreadyApplied: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
nativeRotationDegrees: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
userRotationDegrees: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse;
  return proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPreviousRotationDegrees(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEffectiveRotationDegrees(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setGeometryRevision(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAlreadyApplied(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNativeRotationDegrees(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserRotationDegrees(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPreviousRotationDegrees();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getEffectiveRotationDegrees();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getGeometryRevision();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAlreadyApplied();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getUserRotationDegrees();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 previous_rotation_degrees = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.getPreviousRotationDegrees = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.setPreviousRotationDegrees = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 effective_rotation_degrees = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.getEffectiveRotationDegrees = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.setEffectiveRotationDegrees = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 geometry_revision = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.getGeometryRevision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.setGeometryRevision = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool already_applied = 6;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.getAlreadyApplied = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.setAlreadyApplied = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional int32 native_rotation_degrees = 7;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.getNativeRotationDegrees = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.setNativeRotationDegrees = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.clearNativeRotationDegrees = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.hasNativeRotationDegrees = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int32 user_rotation_degrees = 8;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.getUserRotationDegrees = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.RotateArchitecturalPlanPageResponse.prototype.setUserRotationDegrees = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
iccBookId: jspb.Message.getFieldWithDefault(msg, 3, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest;
  return proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccBookId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getIccBookId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string icc_book_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest.prototype.getIccBookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest.prototype.setIccBookId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string file_id = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetApplicableCodeSectionsRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
iccBookId: jspb.Message.getFieldWithDefault(msg, 3, ""),
maxDepth: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest;
  return proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccBookId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxDepth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIccBookId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMaxDepth();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string icc_book_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest.prototype.getIccBookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest.prototype.setIccBookId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 max_depth = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest.prototype.getMaxDepth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetIccBookTableOfContentsRequest.prototype.setMaxDepth = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
iccBookId: jspb.Message.getFieldWithDefault(msg, 1, ""),
query: jspb.Message.getFieldWithDefault(msg, 2, ""),
maxResults: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest;
  return proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccBookId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIccBookId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMaxResults();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string icc_book_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.prototype.getIccBookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.prototype.setIccBookId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string query = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 max_results = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.prototype.getMaxResults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.prototype.setMaxResults = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.toObject = function(includeInstance, msg) {
  var f, obj = {
vectorEmbeddingRecord: (f = msg.getVectorEmbeddingRecord()) && rag_pb.VectorEmbeddingRecord.toObject(includeInstance, f),
similarityScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult}
 */
proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult;
  return proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult}
 */
proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new rag_pb.VectorEmbeddingRecord;
      reader.readMessage(value,rag_pb.VectorEmbeddingRecord.deserializeBinaryFromReader);
      msg.setVectorEmbeddingRecord(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSimilarityScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVectorEmbeddingRecord();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      rag_pb.VectorEmbeddingRecord.serializeBinaryToWriter
    );
  }
  f = message.getSimilarityScore();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
};


/**
 * optional org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord vector_embedding_record = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord}
 */
proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.prototype.getVectorEmbeddingRecord = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord} */ (
    jspb.Message.getWrapperField(this, rag_pb.VectorEmbeddingRecord, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult} returns this
*/
proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.prototype.setVectorEmbeddingRecord = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult} returns this
 */
proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.prototype.clearVectorEmbeddingRecord = function() {
  return this.setVectorEmbeddingRecord(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.prototype.hasVectorEmbeddingRecord = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float similarity_score = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.prototype.getSimilarityScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult} returns this
 */
proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.prototype.setSimilarityScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
resultsList: jspb.Message.toObjectList(msg.getResultsList(),
    proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.toObject, includeInstance),
iccCodeSearchRequest: (f = msg.getIccCodeSearchRequest()) && proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse;
  return proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.deserializeBinaryFromReader);
      msg.addResults(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.deserializeBinaryFromReader);
      msg.setIccCodeSearchRequest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult.serializeBinaryToWriter
    );
  }
  f = message.getIccCodeSearchRequest();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest.serializeBinaryToWriter
    );
  }
};


/**
 * repeated IccCodeSearchResult results = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult>}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.prototype.getResultsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.prototype.setResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.prototype.addResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.service.IccCodeSearchResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.prototype.clearResultsList = function() {
  return this.setResultsList([]);
};


/**
 * optional GetIccCodeSearchResultsRequest icc_code_search_request = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.prototype.getIccCodeSearchRequest = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsRequest|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.prototype.setIccCodeSearchRequest = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.prototype.clearIccCodeSearchRequest = function() {
  return this.setIccCodeSearchRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GetIccCodeSearchResultsResponse.prototype.hasIccCodeSearchRequest = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
fileId: jspb.Message.getFieldWithDefault(msg, 3, ""),
regionPath: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest;
  return proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegionPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRegionPath();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string file_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string region_path = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest.prototype.getRegionPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptRequest.prototype.setRegionPath = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
region: (f = msg.getRegion()) && proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse;
  return proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.deserializeBinaryFromReader);
      msg.setRegion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRegion();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.serializeBinaryToWriter
    );
  }
};


/**
 * optional RegionHierarchyTreeNode region = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse.prototype.getRegion = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse.prototype.setRegion = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse.prototype.clearRegion = function() {
  return this.setRegion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionTranscriptResponse.prototype.hasRegion = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
fileId: jspb.Message.getFieldWithDefault(msg, 3, ""),
regionPath: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest;
  return proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegionPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRegionPath();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string file_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string region_path = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest.prototype.getRegionPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropRequest.prototype.setRegionPath = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
croppedPng: msg.getCroppedPng_asB64(),
region: (f = msg.getRegion()) && proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse;
  return proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCroppedPng(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.deserializeBinaryFromReader);
      msg.setRegion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCroppedPng_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getRegion();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.serializeBinaryToWriter
    );
  }
};


/**
 * optional bytes cropped_png = 1;
 * @return {!(string|Uint8Array)}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse.prototype.getCroppedPng = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes cropped_png = 1;
 * This is a type-conversion wrapper around `getCroppedPng()`
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse.prototype.getCroppedPng_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCroppedPng()));
};


/**
 * optional bytes cropped_png = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCroppedPng()`
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse.prototype.getCroppedPng_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCroppedPng()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse.prototype.setCroppedPng = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional RegionHierarchyTreeNode region = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse.prototype.getRegion = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse.prototype.setRegion = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse.prototype.clearRegion = function() {
  return this.setRegion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GetRegionCropResponse.prototype.hasRegion = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
fileId: jspb.Message.getFieldWithDefault(msg, 3, ""),
boundingBoxList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
maxLongEdgePixels: jspb.Message.getFieldWithDefault(msg, 5, 0),
highlightBox: (f = msg.getHighlightBox()) && proto.org.codetricks.construction.code.assistant.service.PagePointsBox.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest;
  return proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 4:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addBoundingBox(values[i]);
      }
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxLongEdgePixels(value);
      break;
    case 6:
      var value = new proto.org.codetricks.construction.code.assistant.service.PagePointsBox;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.PagePointsBox.deserializeBinaryFromReader);
      msg.setHighlightBox(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBoundingBoxList();
  if (f.length > 0) {
    writer.writePackedInt32(
      4,
      f
    );
  }
  f = message.getMaxLongEdgePixels();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getHighlightBox();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.org.codetricks.construction.code.assistant.service.PagePointsBox.serializeBinaryToWriter
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string file_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated int32 bounding_box = 4;
 * @return {!Array<number>}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.prototype.getBoundingBoxList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.prototype.setBoundingBoxList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.prototype.addBoundingBox = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.prototype.clearBoundingBoxList = function() {
  return this.setBoundingBoxList([]);
};


/**
 * optional int32 max_long_edge_pixels = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.prototype.getMaxLongEdgePixels = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.prototype.setMaxLongEdgePixels = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional PagePointsBox highlight_box = 6;
 * @return {?proto.org.codetricks.construction.code.assistant.service.PagePointsBox}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.prototype.getHighlightBox = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.PagePointsBox} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.PagePointsBox, 6));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.PagePointsBox|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.prototype.setHighlightBox = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.prototype.clearHighlightBox = function() {
  return this.setHighlightBox(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropRequest.prototype.hasHighlightBox = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.PagePointsBox.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.PagePointsBox.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.PagePointsBox} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.PagePointsBox.toObject = function(includeInstance, msg) {
  var f, obj = {
x: jspb.Message.getFieldWithDefault(msg, 1, 0),
y: jspb.Message.getFieldWithDefault(msg, 2, 0),
width: jspb.Message.getFieldWithDefault(msg, 3, 0),
height: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PagePointsBox}
 */
proto.org.codetricks.construction.code.assistant.service.PagePointsBox.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.PagePointsBox;
  return proto.org.codetricks.construction.code.assistant.service.PagePointsBox.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.PagePointsBox} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PagePointsBox}
 */
proto.org.codetricks.construction.code.assistant.service.PagePointsBox.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setY(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.PagePointsBox.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.PagePointsBox.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.PagePointsBox} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.PagePointsBox.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int32 x = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PagePointsBox.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PagePointsBox} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PagePointsBox.prototype.setX = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 y = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PagePointsBox.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PagePointsBox} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PagePointsBox.prototype.setY = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 width = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PagePointsBox.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PagePointsBox} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PagePointsBox.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 height = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PagePointsBox.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PagePointsBox} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PagePointsBox.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
cropImage: msg.getCropImage_asB64(),
mimeType: jspb.Message.getFieldWithDefault(msg, 2, ""),
widthPixels: jspb.Message.getFieldWithDefault(msg, 3, 0),
heightPixels: jspb.Message.getFieldWithDefault(msg, 4, 0),
renderDpi: jspb.Message.getFieldWithDefault(msg, 5, 0),
displayRotationDegrees: jspb.Message.getFieldWithDefault(msg, 6, 0),
boundingBoxList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
label: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse;
  return proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCropImage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidthPixels(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeightPixels(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRenderDpi(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayRotationDegrees(value);
      break;
    case 7:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addBoundingBox(values[i]);
      }
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCropImage_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWidthPixels();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getHeightPixels();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getRenderDpi();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getDisplayRotationDegrees();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getBoundingBoxList();
  if (f.length > 0) {
    writer.writePackedInt32(
      7,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional bytes crop_image = 1;
 * @return {!(string|Uint8Array)}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.getCropImage = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes crop_image = 1;
 * This is a type-conversion wrapper around `getCropImage()`
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.getCropImage_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCropImage()));
};


/**
 * optional bytes crop_image = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCropImage()`
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.getCropImage_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCropImage()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.setCropImage = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional string mime_type = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 width_pixels = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.getWidthPixels = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.setWidthPixels = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 height_pixels = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.getHeightPixels = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.setHeightPixels = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 render_dpi = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.getRenderDpi = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.setRenderDpi = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 display_rotation_degrees = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.getDisplayRotationDegrees = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.setDisplayRotationDegrees = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated int32 bounding_box = 7;
 * @return {!Array<number>}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.getBoundingBoxList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.setBoundingBoxList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.addBoundingBox = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.clearBoundingBoxList = function() {
  return this.setBoundingBoxList([]);
};


/**
 * optional string label = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageCropResponse.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
fileId: jspb.Message.getFieldWithDefault(msg, 3, ""),
regionPath: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest}
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest;
  return proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest}
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegionPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRegionPath();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string file_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string region_path = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest.prototype.getRegionPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenRequest.prototype.setRegionPath = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
childrenList: jspb.Message.toObjectList(msg.getChildrenList(),
    proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse}
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse;
  return proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse}
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.deserializeBinaryFromReader);
      msg.addChildren(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChildrenList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RegionHierarchyTreeNode children = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode>}
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse.prototype.getChildrenList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse.prototype.setChildrenList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode}
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse.prototype.addChildren = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ListRegionChildrenResponse.prototype.clearChildrenList = function() {
  return this.setChildrenList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
fileId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest;
  return proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string file_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
pageExplanationMarkdown: jspb.Message.getFieldWithDefault(msg, 1, ""),
topLevelRegionsList: jspb.Message.toObjectList(msg.getTopLevelRegionsList(),
    proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.toObject, includeInstance),
sheetId: jspb.Message.getFieldWithDefault(msg, 3, ""),
pageTitle: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse;
  return proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageExplanationMarkdown(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.deserializeBinaryFromReader);
      msg.addTopLevelRegions(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSheetId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageTitle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageExplanationMarkdown();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTopLevelRegionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode.serializeBinaryToWriter
    );
  }
  f = message.getSheetId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPageTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string page_explanation_markdown = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.prototype.getPageExplanationMarkdown = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.prototype.setPageExplanationMarkdown = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated RegionHierarchyTreeNode top_level_regions = 2;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode>}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.prototype.getTopLevelRegionsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode, 2));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.prototype.setTopLevelRegionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.prototype.addTopLevelRegions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.org.codetricks.construction.code.assistant.service.RegionHierarchyTreeNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.prototype.clearTopLevelRegionsList = function() {
  return this.setTopLevelRegionsList([]);
};


/**
 * optional string sheet_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.prototype.getSheetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.prototype.setSheetId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string page_title = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.prototype.getPageTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetPageSummaryResponse.prototype.setPageTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
query: jspb.Message.getFieldWithDefault(msg, 2, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 3, ""),
pages: jspb.Message.getFieldWithDefault(msg, 4, ""),
maxHits: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest;
  return proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPages(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxHits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPages();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMaxHits();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string query = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string pages = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.prototype.getPages = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.prototype.setPages = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 max_hits = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.prototype.getMaxHits = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextRequest.prototype.setMaxHits = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.repeatedFields_ = [7,11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.toObject = function(includeInstance, msg) {
  var f, obj = {
fileId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
sheetId: jspb.Message.getFieldWithDefault(msg, 3, ""),
matchedText: jspb.Message.getFieldWithDefault(msg, 4, ""),
words: jspb.Message.getFieldWithDefault(msg, 5, ""),
context: jspb.Message.getFieldWithDefault(msg, 6, ""),
boundingBoxList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
textSelector: (f = msg.getTextSelector()) && plan_reviewer_pb.OcrTextSelector.toObject(includeInstance, f),
meanConfidence: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
source: jspb.Message.getFieldWithDefault(msg, 10, ""),
lineBoxesList: jspb.Message.toObjectList(msg.getLineBoxesList(),
    proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit;
  return proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSheetId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatchedText(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setWords(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setContext(value);
      break;
    case 7:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addBoundingBox(values[i]);
      }
      break;
    case 8:
      var value = new plan_reviewer_pb.OcrTextSelector;
      reader.readMessage(value,plan_reviewer_pb.OcrTextSelector.deserializeBinaryFromReader);
      msg.setTextSelector(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMeanConfidence(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 11:
      var value = new proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.deserializeBinaryFromReader);
      msg.addLineBoxes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSheetId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMatchedText();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getWords();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getContext();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBoundingBoxList();
  if (f.length > 0) {
    writer.writePackedInt32(
      7,
      f
    );
  }
  f = message.getTextSelector();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      plan_reviewer_pb.OcrTextSelector.serializeBinaryToWriter
    );
  }
  f = message.getMeanConfidence();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLineBoxesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.serializeBinaryToWriter
    );
  }
};


/**
 * optional string file_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string sheet_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.getSheetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.setSheetId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string matched_text = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.getMatchedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.setMatchedText = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string words = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.getWords = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.setWords = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string context = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.getContext = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.setContext = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated int32 bounding_box = 7;
 * @return {!Array<number>}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.getBoundingBoxList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.setBoundingBoxList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.addBoundingBox = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.clearBoundingBoxList = function() {
  return this.setBoundingBoxList([]);
};


/**
 * optional org.codetricks.construction.code.assistant.OcrTextSelector text_selector = 8;
 * @return {?proto.org.codetricks.construction.code.assistant.OcrTextSelector}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.getTextSelector = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.OcrTextSelector} */ (
    jspb.Message.getWrapperField(this, plan_reviewer_pb.OcrTextSelector, 8));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.OcrTextSelector|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit} returns this
*/
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.setTextSelector = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.clearTextSelector = function() {
  return this.setTextSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.hasTextSelector = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional double mean_confidence = 9;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.getMeanConfidence = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.setMeanConfidence = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional string source = 10;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * repeated PlanTextSearchBox line_boxes = 11;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox>}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.getLineBoxesList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox, 11));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit} returns this
*/
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.setLineBoxesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.addLineBoxes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.prototype.clearLineBoxesList = function() {
  return this.setLineBoxesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.toObject = function(includeInstance, msg) {
  var f, obj = {
boundingBoxList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox;
  return proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addBoundingBox(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBoundingBoxList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 bounding_box = 1;
 * @return {!Array<number>}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.prototype.getBoundingBoxList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.prototype.setBoundingBoxList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.prototype.addBoundingBox = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchBox.prototype.clearBoundingBoxList = function() {
  return this.setBoundingBoxList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.toObject = function(includeInstance, msg) {
  var f, obj = {
fileId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
sheetId: jspb.Message.getFieldWithDefault(msg, 3, ""),
searched: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
textRecognition: jspb.Message.getFieldWithDefault(msg, 5, ""),
failureReason: jspb.Message.getFieldWithDefault(msg, 6, ""),
textLayer: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage;
  return proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSheetId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSearched(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextRecognition(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFailureReason(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextLayer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSheetId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSearched();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getTextRecognition();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFailureReason();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTextLayer();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string file_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string sheet_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.prototype.getSheetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.prototype.setSheetId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool searched = 4;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.prototype.getSearched = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.prototype.setSearched = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string text_recognition = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.prototype.getTextRecognition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.prototype.setTextRecognition = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string failure_reason = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.prototype.getFailureReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.prototype.setFailureReason = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string text_layer = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.prototype.getTextLayer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.prototype.setTextLayer = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.repeatedFields_ = [3,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
query: jspb.Message.getFieldWithDefault(msg, 1, ""),
normalizedQuery: jspb.Message.getFieldWithDefault(msg, 2, ""),
hitsList: jspb.Message.toObjectList(msg.getHitsList(),
    proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.toObject, includeInstance),
totalHits: jspb.Message.getFieldWithDefault(msg, 4, 0),
coverageSummary: jspb.Message.getFieldWithDefault(msg, 5, ""),
pagesListed: jspb.Message.getFieldWithDefault(msg, 6, 0),
pagesSearched: jspb.Message.getFieldWithDefault(msg, 7, 0),
pagesOfNoteList: jspb.Message.toObjectList(msg.getPagesOfNoteList(),
    proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse;
  return proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNormalizedQuery(value);
      break;
    case 3:
      var value = new proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.deserializeBinaryFromReader);
      msg.addHits(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalHits(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoverageSummary(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPagesListed(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPagesSearched(value);
      break;
    case 8:
      var value = new proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.deserializeBinaryFromReader);
      msg.addPagesOfNote(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNormalizedQuery();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHitsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit.serializeBinaryToWriter
    );
  }
  f = message.getTotalHits();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getCoverageSummary();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPagesListed();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getPagesSearched();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getPagesOfNoteList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage.serializeBinaryToWriter
    );
  }
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string normalized_query = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.getNormalizedQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.setNormalizedQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated PlanTextSearchHit hits = 3;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit>}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.getHitsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit, 3));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.setHitsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.addHits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.org.codetricks.construction.code.assistant.service.PlanTextSearchHit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.clearHitsList = function() {
  return this.setHitsList([]);
};


/**
 * optional int32 total_hits = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.getTotalHits = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.setTotalHits = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string coverage_summary = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.getCoverageSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.setCoverageSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 pages_listed = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.getPagesListed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.setPagesListed = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 pages_searched = 7;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.getPagesSearched = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.setPagesSearched = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * repeated PlanTextSearchPage pages_of_note = 8;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage>}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.getPagesOfNoteList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage, 8));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.setPagesOfNoteList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.addPagesOfNote = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.org.codetricks.construction.code.assistant.service.PlanTextSearchPage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanTextResponse.prototype.clearPagesOfNoteList = function() {
  return this.setPagesOfNoteList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
query: jspb.Message.getFieldWithDefault(msg, 2, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 3, ""),
pages: jspb.Message.getFieldWithDefault(msg, 4, ""),
maxResults: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest;
  return proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPages(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPages();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMaxResults();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string query = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string pages = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.prototype.getPages = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.prototype.setPages = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 max_results = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.prototype.getMaxResults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesRequest.prototype.setMaxResults = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanHitEntity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
kind: jspb.Message.getFieldWithDefault(msg, 2, ""),
title: jspb.Message.getFieldWithDefault(msg, 3, ""),
path: jspb.Message.getFieldWithDefault(msg, 4, ""),
parentId: jspb.Message.getFieldWithDefault(msg, 5, ""),
parentTitle: jspb.Message.getFieldWithDefault(msg, 6, ""),
labelBoxList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanHitEntity}
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.PlanHitEntity;
  return proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanHitEntity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanHitEntity}
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setKind(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentTitle(value);
      break;
    case 7:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addLabelBox(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanHitEntity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getKind();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getParentId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getParentTitle();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLabelBoxList();
  if (f.length > 0) {
    writer.writePackedInt32(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanHitEntity} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string kind = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.prototype.getKind = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanHitEntity} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.prototype.setKind = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanHitEntity} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string path = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanHitEntity} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string parent_id = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.prototype.getParentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanHitEntity} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.prototype.setParentId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string parent_title = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.prototype.getParentTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanHitEntity} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.prototype.setParentTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated int32 label_box = 7;
 * @return {!Array<number>}
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.prototype.getLabelBoxList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanHitEntity} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.prototype.setLabelBoxList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanHitEntity} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.prototype.addLabelBox = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanHitEntity} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.prototype.clearLabelBoxList = function() {
  return this.setLabelBoxList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.toObject = function(includeInstance, msg) {
  var f, obj = {
fileId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
sheetId: jspb.Message.getFieldWithDefault(msg, 3, ""),
text: jspb.Message.getFieldWithDefault(msg, 4, ""),
boundingBoxList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
matchedBy: jspb.Message.getFieldWithDefault(msg, 6, 0),
keywordRank: jspb.Message.getFieldWithDefault(msg, 7, 0),
meaningRank: jspb.Message.getFieldWithDefault(msg, 8, 0),
score: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
source: jspb.Message.getFieldWithDefault(msg, 10, ""),
entity: (f = msg.getEntity()) && proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit}
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.PlanPassageHit;
  return proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit}
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSheetId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 5:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addBoundingBox(values[i]);
      }
      break;
    case 6:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.service.PassageMatch} */ (reader.readEnum());
      msg.setMatchedBy(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setKeywordRank(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMeaningRank(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 11:
      var value = new proto.org.codetricks.construction.code.assistant.service.PlanHitEntity;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.deserializeBinaryFromReader);
      msg.setEntity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSheetId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBoundingBoxList();
  if (f.length > 0) {
    writer.writePackedInt32(
      5,
      f
    );
  }
  f = message.getMatchedBy();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getKeywordRank();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getMeaningRank();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getEntity();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.org.codetricks.construction.code.assistant.service.PlanHitEntity.serializeBinaryToWriter
    );
  }
};


/**
 * optional string file_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string sheet_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.getSheetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.setSheetId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string text = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated int32 bounding_box = 5;
 * @return {!Array<number>}
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.getBoundingBoxList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.setBoundingBoxList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.addBoundingBox = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.clearBoundingBoxList = function() {
  return this.setBoundingBoxList([]);
};


/**
 * optional PassageMatch matched_by = 6;
 * @return {!proto.org.codetricks.construction.code.assistant.service.PassageMatch}
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.getMatchedBy = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.service.PassageMatch} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.PassageMatch} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.setMatchedBy = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional int32 keyword_rank = 7;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.getKeywordRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.setKeywordRank = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 meaning_rank = 8;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.getMeaningRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.setMeaningRank = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional double score = 9;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional string source = 10;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional PlanHitEntity entity = 11;
 * @return {?proto.org.codetricks.construction.code.assistant.service.PlanHitEntity}
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.getEntity = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.PlanHitEntity} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.PlanHitEntity, 11));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.PlanHitEntity|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit} returns this
*/
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.setEntity = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.clearEntity = function() {
  return this.setEntity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.prototype.hasEntity = function() {
  return jspb.Message.getField(this, 11) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.repeatedFields_ = [2,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
query: jspb.Message.getFieldWithDefault(msg, 1, ""),
hitsList: jspb.Message.toObjectList(msg.getHitsList(),
    proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.toObject, includeInstance),
indexed: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
indexSummary: jspb.Message.getFieldWithDefault(msg, 4, ""),
indexState: jspb.Message.getFieldWithDefault(msg, 5, 0),
pagesIndexed: jspb.Message.getFieldWithDefault(msg, 6, 0),
pagesTotal: jspb.Message.getFieldWithDefault(msg, 7, 0),
pagesNotIndexedList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse;
  return proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.service.PlanPassageHit;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.deserializeBinaryFromReader);
      msg.addHits(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIndexed(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexSummary(value);
      break;
    case 5:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.service.PassageIndexState} */ (reader.readEnum());
      msg.setIndexState(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPagesIndexed(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPagesTotal(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addPagesNotIndexed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHitsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.service.PlanPassageHit.serializeBinaryToWriter
    );
  }
  f = message.getIndexed();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getIndexSummary();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIndexState();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getPagesIndexed();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getPagesTotal();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getPagesNotIndexedList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated PlanPassageHit hits = 2;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit>}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.getHitsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.PlanPassageHit, 2));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.setHitsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanPassageHit}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.addHits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.org.codetricks.construction.code.assistant.service.PlanPassageHit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.clearHitsList = function() {
  return this.setHitsList([]);
};


/**
 * optional bool indexed = 3;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.getIndexed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.setIndexed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string index_summary = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.getIndexSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.setIndexSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional PassageIndexState index_state = 5;
 * @return {!proto.org.codetricks.construction.code.assistant.service.PassageIndexState}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.getIndexState = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.service.PassageIndexState} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.PassageIndexState} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.setIndexState = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int32 pages_indexed = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.getPagesIndexed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.setPagesIndexed = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 pages_total = 7;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.getPagesTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.setPagesTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * repeated string pages_not_indexed = 8;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.getPagesNotIndexedList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.setPagesNotIndexedList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.addPagesNotIndexed = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.SearchPlanPassagesResponse.prototype.clearPagesNotIndexedList = function() {
  return this.setPagesNotIndexedList([]);
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.service.RegionFrameProvenance = {
  REGION_FRAME_PROVENANCE_UNSPECIFIED: 0,
  REGION_FRAME_GENERATED: 1,
  REGION_FRAME_ASSUMED: 2,
  REGION_FRAME_HEALED: 3,
  REGION_FRAME_UNTRACKED: 4,
  REGION_FRAME_UNSUPPORTED: 5
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPositionAvailability = {
  PAGE_TEXT_POSITION_AVAILABILITY_UNSPECIFIED: 0,
  PAGE_TEXT_POSITION_AVAILABLE: 1,
  PAGE_TEXT_POSITION_PENDING: 2,
  PAGE_TEXT_POSITION_MISSING: 3,
  PAGE_TEXT_POSITION_FAILED: 4
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.service.PageTextPositionFailureReason = {
  PAGE_TEXT_POSITION_FAILURE_REASON_UNSPECIFIED: 0,
  PAGE_TEXT_POSITION_FAILURE_NONE: 1,
  PAGE_TEXT_POSITION_FAILURE_OCR_ENGINE_UNAVAILABLE: 2,
  PAGE_TEXT_POSITION_FAILURE_OCR_EXTRACTION_FAILED: 3,
  PAGE_TEXT_POSITION_FAILURE_PDF_INPUT_INVALID: 4,
  PAGE_TEXT_POSITION_FAILURE_ARTIFACT_INVALID: 5,
  PAGE_TEXT_POSITION_FAILURE_STORAGE_ACCESS_FAILED: 6
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.service.DocumentType = {
  DOCUMENT_TYPE_UNKNOWN: 0,
  DOCUMENT_TYPE_ARCHITECTURAL_PLAN: 1,
  DOCUMENT_TYPE_MECHANICAL_PLAN: 2,
  DOCUMENT_TYPE_ELECTRICAL_PLAN: 3,
  DOCUMENT_TYPE_STRUCTURAL_PLAN: 4,
  DOCUMENT_TYPE_INSPECTOR_FEEDBACK: 5,
  DOCUMENT_TYPE_PERMIT_APPLICATION: 6,
  DOCUMENT_TYPE_CODE_COMPLIANCE_REPORT: 7,
  DOCUMENT_TYPE_SITE_PLAN: 8,
  DOCUMENT_TYPE_ELEVATION_DRAWING: 9,
  DOCUMENT_TYPE_SECTION_DRAWING: 10
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.service.ProcessingStatus = {
  PROCESSING_STATUS_UNKNOWN: 0,
  PROCESSING_STATUS_UPLOADED: 1,
  PROCESSING_STATUS_PROCESSING: 2,
  PROCESSING_STATUS_COMPLETED: 3,
  PROCESSING_STATUS_FAILED: 4
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.service.PassageMatch = {
  PASSAGE_MATCH_UNSPECIFIED: 0,
  PASSAGE_MATCH_KEYWORD: 1,
  PASSAGE_MATCH_MEANING: 2,
  PASSAGE_MATCH_KEYWORD_AND_MEANING: 3
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.service.PassageIndexState = {
  PASSAGE_INDEX_STATE_UNSPECIFIED: 0,
  PASSAGE_INDEX_STATE_NONE: 1,
  PASSAGE_INDEX_STATE_CURRENT: 2,
  PASSAGE_INDEX_STATE_PARTIAL: 3,
  PASSAGE_INDEX_STATE_OUTDATED: 4
};

goog.object.extend(exports, proto.org.codetricks.construction.code.assistant.service);
